import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\"><path d=\"M.85 1.714h21\" class=\"menu--top\"></path><path d=\"M.85 9.214h21\" class=\"menu--middle\"></path><path d=\"M.85 9.214h21\" class=\"menu--middle-2\"></path><path d=\"M.85 16.714 11.5 16.5\" class=\"menu--bottom\"></path></g>", 1)
  ]))]))
}
export default { render: render }